import { ErrorState } from "@leagueplatform/web-common-components";
import { StackLayout } from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";

export const PageNotFound = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout
      horizontalAlignment="center"
      verticalAlignment="center"
      css={{
        position: "absolute",
        height: "100%",
        width: "100%",
      }}
    >
      <ErrorState
        headingString={formatMessage({ id: "STR_SORRY_WE_CANT_FIND_PAGE" })}
        error={null}
      />
    </StackLayout>
  );
};
